import React, { useCallback } from 'react';
import { func } from 'prop-types';
import { useTrackMessageVisibilityEffect, withVisibilityLogic } from 'mangools-react-components/src';
import { useSelector, useDispatch } from 'react-redux';

import MessageHolder from 'components/messages/MessageHolder';

import { currentColorSchemeSelector } from 'selectors/uiSelectors';

import upgradeImg from 'images/upgrade.svg';
import mnglsImage from 'images/mangools-logo-full.svg';
import mnglsImageWhite from 'images/mangools-logo-full-white.svg';

import { gtmTrack } from 'actions/analyticsActions';
import { analyticsEvents, analyticsActions } from 'constants/analytics';
import InvalidInputMessageContent from './InvalidInputMessageContent';

function InvalidInputMessage(props) {
    const dispatch = useDispatch();
    const colorScheme = useSelector(state => currentColorSchemeSelector(state));

    const onGtmTrack = useCallback(
        payload => {
            dispatch(gtmTrack(payload));
        },
        [dispatch],
    );

    const handleOkClick = () => {
        onGtmTrack({
            action: analyticsActions.CONFIRM,
            event: analyticsEvents.INVALID_INPUT_MESSAGE,
        });
        props.onClose();
    };

    useTrackMessageVisibilityEffect(analyticsEvents.INVALID_INPUT_MESSAGE, onGtmTrack, { source: 'sw' });

    return (
        <MessageHolder onClose={props.onClose}>
            <InvalidInputMessageContent
                colorScheme={colorScheme}
                juiceImage={upgradeImg}
                mangoolsLogoImage={mnglsImage}
                mangoolsLogoWhiteImage={mnglsImageWhite}
                onClose={handleOkClick}
            />
        </MessageHolder>
    );
}

InvalidInputMessage.propTypes = {
    onClose: func.isRequired,
};

export default withVisibilityLogic(React.memo(InvalidInputMessage));
